import { last, template } from 'lodash-es'
import { iconMap } from '../use-amap/icon/iconMap'

// 在这里拼好弹窗就可以
// 语法参考 https://lodash.com/docs/4.17.15#template
const defaultUserInfoTemplate = template(`
  hello <%= user.name %>!
`)

export default function userPolyLine(
  opts = {
    gridSize: 60,
  }
) {
  const render = (AMap, amap, polyLinesLayer, usersLayer) => {
    return () => {
      polyLinesLayer.render()
      usersLayer.render()
      amap.setFitView()
    }
  }

  const renderPolyLines = (AMap, amap, layer) => {
    return () => {
      const clockIcon = new AMap.Icon({
        size: new AMap.Size(32, 32),
        image: iconMap.clock,
      })
      const inspectIcon = new AMap.Icon({
        size: new AMap.Size(32, 32),
        image: iconMap.inspect,
      })
      const polylines = (layer.data.paths || [])
        .map((userPath) => {
          const userPolyLine =
            userPath.path?.length > 1
              ? new AMap.Polyline({
                  map: amap,
                  path: userPath.path,
                  showDir: true,
                  strokeColor: layer.data.strokeColor || '#28F', //线颜色
                  // strokeOpacity: 1,     //线透明度
                  strokeWeight: layer.data.strokeWeight || 6, //线宽
                  // strokeStyle: "solid"  //线样式
                })
              : null
          const signInMarkers = userPath.signIn.map(
            (item) =>
              new AMap.Marker({
                map: amap,
                position: [item.lng, item.lat],
                title: item.objectId,
                icon: clockIcon,
                anchor: 'bottom-center',
              })
          )
          const inspectMarkers = userPath.inspect.map(
            (item) =>
              new AMap.Marker({
                map: amap,
                position: [item.lng, item.lat],
                title: item.objectId,
                icon: inspectIcon,
                anchor: 'bottom-center',
              })
          )
          return {
            userPolyLine,
            inspectMarkers,
            signInMarkers,
          }
        })
        .filter((x) => x)
      layer.polylines = polylines
    }
  }

  const renderUsers = (AMap, amap, layer) => {
    const geocoder = new AMap.Geocoder({
      radius: 1000,
    })
    return () => {
      // const useInfoWindow = new AMap.InfoWindow()
      layer.useInfoWindow = new AMap.InfoWindow()
      layer.markers = layer.users
        .map((user) => {
          if (user && user.position) {
            const userMarker = new AMap.Marker({
              name: user.name || '匿名用户', // 此属性非绘制文字内容，仅最为标识使用
              position: user.position,
              content: user.userMarkerContent,
              anchor: 'bottom-center',
            })

            const userLnglat = new AMap.LngLat(...user.position)

            userMarker.on('click', ({ lnglat }) => {
              if (typeof user.onMarkerClick === 'function') {
                geocoder.getAddress(userLnglat, (status, result) => {
                  if (status === 'complete' && result.regeocode) {
                    user.onMarkerClick(result.regeocode.formattedAddress)
                  } else {
                    user.onMarkerClick()
                  }
                })
              }
              let content = user.infoWindow
              if (!content) return
              layer.useInfoWindow.setContent(content)
              layer.useInfoWindow.open(amap, lnglat)
            })
            return userMarker
          }
          return null
        })
        .filter((x) => x)
      amap.add(layer.markers)
    }
  }

  const clear = (AMap, amap) => {
    return () => {
      amap.clearMap()
    }
  }

  const init = (AMap, amap, layer) => {
    layer.render = render(AMap, amap, layer)
    layer.clusterers = {}
    layer.clear = clear(AMap, amap, layer)
  }

  const setUserData = (AMap, amap, layer) => {
    /**
     * 设置当前选中的用户轨迹
     * @param {*} path 原始数据
     * @returns
     */
    return (paths) => {
      layer.data.paths = paths
    }
  }

  const setApis = (AMap, amap) => {
    return {
      initUserPolyline: (layer, usersLayer, extFunc) => {
        layer.render = renderPolyLines(AMap, amap, layer)
        layer.clear = clear(AMap, amap)
        // layer.reset = reset(AMap, amap)
        layer.setUserData = setUserData(AMap, amap, layer)

        // amap.renderSample = renderSample(AMap, amap, layer, usersLayer)

        // layer.renderSample = renderSample(AMap, amap, layer, usersLayer)
        // layer.setUsers = setUsers(AMap, amap, layer)

        usersLayer.layer = new AMap.LabelsLayer({
          // amap,
          zooms: [3, 20],
          zIndex: 1000,
          // 该层内标注是否避让
          collision: true,
          // 设置 allowCollision：true，可以让标注避让用户的标注
          allowCollision: true,
        })

        usersLayer.users = []
        usersLayer.setUsers = (users) => {
          usersLayer.users = users
        }
        usersLayer.render = renderUsers(AMap, amap, usersLayer)

        if (extFunc) {
          extFunc(layer)
        }
        return layer
      },
    }
  }

  return {
    amapPlugins: ['AMap.Geocoder'],
    init,
    setApis,
  }
}
